// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Marker_wrapper__uMKzS","marker":"Marker_marker__3cBcX","marker_hover":"Marker_marker_hover__2hk_1 Marker_marker__3cBcX","card":"Marker_card__3ojC8"};